<div id="generate-course-form-source" class="text-center d-none">
    <h1>Fuente</h1>
    <p>¿Desde dónde quiere extraer el contenido del curso?</p>

    <div class="container row m-auto">
        <div id="generate-course-form-source-blank" class="generate-course-form-element">
            <h2>En blanco</h2>
            <p>Curso en blanco</p>

            <button class="btn btn-success" (click)="generateBlankCourse()" [attr.disabled]="generateBlankCourseLoading || generateBlankCourseSuccess ? 'disabled' : null">
                <i class="fas fa-book"></i>
                <span>Crear curso</span>
            </button>

            <div id="generate-course-blank-status">
                <div id="generate-course-blank-loading" class="mt-3" *ngIf="generateBlankCourseLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Procesando, espere por favor...</span>
                </div>
                <div id="generate-course-blank-error" class="mt-3 text-danger" *ngIf="generateBlankCourseError">
                    <i class="fa fa-times"></i>
                    <span>El curso no se ha podido generar.</span>
                </div>
                <div id="generate-course-blank-success" class="mt-3 text-success" *ngIf="generateBlankCourseSuccess">
                    <i class="fa fa-check"></i>
                    <span>El curso se ha generado correctamente.</span>
                </div>
            </div>

            <button id="generate-blank-course-redirect" class="btn btn-success mt-3" routerLink="/course/{{ newCourseID }}" routerLinkActive="active" *ngIf="generateBlankCourseSuccess">
                <i class="fa fa-book"></i>
                <span>Ir al curso</span>
            </button>
        </div>
        <div id="generate-course-form-source-wikipedia" class="generate-course-form-element">
            <h2>Wikipedia</h2>
            <p>Generación a partir de artículos de Wikipedia</p>
            <button class="course-form-button" data-direction="forward" data-parent="source" data-next="wikilinks" (click)="move($event)">Seleccionar</button>
        </div>
        <div id="generate-course-form-source-pdf" class="generate-course-form-element">
            <h2>PDF</h2>
            <p>Generación a partir de archivos PDF</p>
            <button class="course-form-button" data-direction="forward" data-parent="source" data-next="pdf" (click)="move($event)">Seleccionar</button>
        </div>
        <!--
        <div id="generate-course-form-source-bloom" class="generate-course-form-element">
            <h2>BLOOM</h2>
            <p>Generación a partir de la inteligencia artificial BLOOM</p>
            <button class="course-form-button" data-direction="forward" data-parent="source" data-next="ai" (click)="move($event)">Seleccionar</button>
        </div>
        -->
        <!--
        <div id="generate-course-form-source-mixed" class="generate-course-form-element">
            <h2>Mixto</h2>
            <p>Combinacion de todos los métodos disponibles</p>
            <button class="course-form-button" data-direction="forward" data-parent="source" data-next="mixed" (click)="move($event)">Seleccionar</button>
        </div>
        -->    
    </div>

    <div class="container row m-auto">
        <button class="btn btn-primary mt-3" data-direction="back" data-parent="source" data-prev="start" (click)="move($event)">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
    </div>
    
</div>